import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const REASON_MESSAGES = {
    store_disabled: 'This store has been disabled by the master administrator. Contact support.',
    session_expired: 'Your session has expired. Please sign in again.',
    subscription_expired: 'Your subscription has expired. Contact the master administrator.',
};

export default function LoginPage() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [form, setForm] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const reason = params.get('reason');
        if (reason && REASON_MESSAGES[reason]) {
            setError(REASON_MESSAGES[reason]);
        }
    }, [location.search]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        const res = await login(form.email, form.password);
        setLoading(false);
        if (res.success) {
            navigate('/admin');
        } else {
            const code = res.code;
            if (code === 'STORE_DISABLED') {
                setError(REASON_MESSAGES.store_disabled);
            } else if (code === 'SUBSCRIPTION_EXPIRED') {
                setError(REASON_MESSAGES.subscription_expired);
            } else {
                setError(typeof res.error === 'string' ? res.error : 'Login failed');
            }
        }
    };

    return (
        <div className="auth-page">
            <form className="auth-card" onSubmit={handleSubmit}>
                <h2>Welcome Back</h2>
                <p>Sign in to your POS account</p>

                {error && <div className="error-banner">{error}</div>}

                <label>Email</label>
                <input
                    type="email"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    required
                />

                <label>Password</label>
                <input
                    type="password"
                    value={form.password}
                    onChange={(e) => setForm({ ...form, password: e.target.value })}
                    required
                />

                <button className="btn" disabled={loading}>
                    {loading ? 'Signing in...' : 'Login'}
                </button>

                <p className="auth-link">
                    Account setup is managed by your master admin.
                </p>
            </form>
        </div>
    );
}
